"use client";
import { usePurchaseEvent } from "@repo/lib/hooks/gtm";
import {
  useTrackPaymentFailure,
  useTrackPurchase,
} from "@repo/lib/hooks/webengage";
import { processOrder } from "@repo/server-actions/checkout";
import { useTranslations } from "next-intl";
import { useRouter } from "next/navigation";
import { useEffect, useRef, useState, useTransition } from "react";

const useOrderStatus = (searchParams, locale) => {
  const router = useRouter();
  const [orderStatus, setOrderStatus] = useState(null);
  const [isPending, startTransition] = useTransition();
  const preventExtraCallRef = useRef(false);
  const { handlePurchaseEvent } = usePurchaseEvent();
  const t = useTranslations("Common");
  const { trackPaymentFailure } = useTrackPaymentFailure();
  const { trackPurchase } = useTrackPurchase();
  useEffect(() => {
    const fetchOrderStatus = async () => {
      startTransition(async () => {
        const transactionData = sessionStorage.getItem("transactionData");
        const selectedMethod = localStorage.getItem("paymentMethod");
        try {
          if (transactionData) {
            const status = await processOrder(
              transactionData,
              selectedMethod,
              searchParams,
              locale
            );
            sessionStorage.removeItem("transactionData");
            setOrderStatus(status);
            const isPaymentSuccess = status?.data?.status === "PAYMENT_SUCCESS";
            if (isPaymentSuccess) {
              handlePurchaseEvent(status?.data);
              trackPurchase(status?.data);
            } else {
              trackPaymentFailure(status?.data);
            }
            //TODO: Delete this once the order status issue is resolved
            /* if (!status?.success) {
              setSnackbar({
                open: true,
                message: t("Something_Went_Wrong_Please_Try_Again"),
                type: "error",
              });
              router.push("/checkout");
            } */
          } else {
            router.push("/");
          }
        } catch (error) {
          console.error("Error fetching order status:", error);
        }
      });
    };
    if (!preventExtraCallRef.current) {
      preventExtraCallRef.current = true;
      fetchOrderStatus();
    }
  }, [
    router,
    searchParams,
    handlePurchaseEvent,
    locale,
    trackPaymentFailure,
    trackPurchase,
  ]);

  return { orderStatus, isPending };
};

export default useOrderStatus;
